export default {
    props: {
        section: {
          type: String,
          required: false,
          default: null,
        },
      },
      data() {
        return {
        
        };
      },
      computed: {
        headerHeight() {
          if (this.isMovil){            
            return 0
          } else {
            return 60
          }
        }
      },
      created() {
        //console.log(`section: ${this.section}`);
      },
      mounted() {
        //console.log('mounted: ', this.section)
        this.$nextTick(() => {
          if (this.section) {
            //console.log(`section: ${this.section}`);
            if (this.isMovil){  
              //console.log('scroll movil');
              this.scrollToSection(this.section) 
            } else {
              //console.log('scroll to section not movil')
              this.scrollToSectionAdjusted(this.section);
            }
          } else {
            //console.log('scroll to 0,0')
            window.scrollTo(0,0)
          }
        });
      },
      updated() {
        this.$nextTick(() => {
          if (this.section) {
           // console.log(`section: ${this.section}`);
            if (this.isMovil){  
            //  console.log('scroll movil');
              this.scrollToSection(this.section) 
            } else {
           //   console.log('scroll to section')
              this.scrollToSectionAdjusted(this.section);
            }
          } else {
          //  console.log("Not section")
          }
        });
      },
      methods: {
        scrollToSection(section) {
         // console.log("metodo scroll");
         // console.log(`Ir a section: ${section}`);
          const selector = document.getElementById(section);
          //const selector = this.$refs[section];
          //console.log(selector);
          selector.scrollIntoView({
            behavior: "smooth",
            block: "start",
            inline: "center",
          });
        },
        scrollToSectionAdjusted(section) {
          //console.log("metodo scroll ajustado");
          const selector = document.getElementById(section);
          // const selector = this.$refs[section];
          //console.log(selector);
          const elementPosition = selector.getBoundingClientRect().top;
          const offsetPosition =
            elementPosition + window.pageYOffset - this.headerHeight;
            //console.log(offsetPosition + " = " + elementPosition + " / " +window.pageYOffset + " / " + this.headerHeight)    
            window.scrollTo({
              top: offsetPosition,
              behavior: "smooth",
            });
        },
        scrollToSectionRouter(section) {
          //console.log("metodo scroll router");
          const selector = document.getElementById(section);
          const headerHeight = 0;
          // const selector = this.$refs[section];
          //console.log(selector);
          const elementPosition = selector.getBoundingClientRect().top;
          const offsetPosition =
            elementPosition + window.pageYOffset - headerHeight;
            //console.log(offsetPosition + " = " + elementPosition + " / " +window.pageYOffset + " / " + headerHeight)    
            window.scrollTo({
              top: offsetPosition,
              behavior: "smooth",
            });
        },
      },
};
